import  { Component } from 'react';
import {RadioBox} from './radiobox';
import {FormError} from './form-errors';
import InfoBulle from './info';
class Demandeur extends Component {

    constructor (props){
        super(props);

        this.state = {
            currentForm : 1,
            errorMessage : [],
            showQuestionAdditionel:null,
            demandeur : {
                age : 'undefined' ,
                etudiant: false,
                chomeur_longue_duree: false,
                handicap: false,
                inapte_travail: false,
                enceinte: false,
                nationalite: "FR",
                echelon_bourse :-1,
                ass_precondition_remplie :false,
                aah_restriction_substantielle_durable_acces_emploi :false,
                taux_incapacite :0.3,
                date_naissance : null,
                enfant_a_charge : false,
                gir: "gir_6",
            }
        };

        this.optionsNationalite = {
            'Française'  : 'FR' ,
            'EEE - UE - Suisse' :'EEE - UE - Suisse' ,
            'Hors UE' :'Hors UE' 
        };

        this.state.situations = {
            "retraite":{
                "value":false,    
                "label":"Retraité-e"
            },
            "handicap":{
                "value":false,    
                "label":"En situation de handicap"
            },
            "inapte_travail":{
                "value":false,
                "label":"Inapte au travail"
            },
            "aucune_situations":{
                "value":false,    
                "label":"En activité / dans aucune de ces situations"
            }
        };

    }

    /*  Event handling methods */
    changeSituationCheck = (situation,e)=>{
        this.setState( ({situations,showQuestionAdditionel})=>{

            situations[situation].value =  e.target.checked;
            const newShowQuestion = situations['handicap'].value ;

            showQuestionAdditionel = (showQuestionAdditionel === null && newShowQuestion === false) ? null : newShowQuestion;

            return {
                situations:situations,
                showQuestionAdditionel:showQuestionAdditionel
            };
        });
    }

    captureTauxIncapacite = (e)=> {
        const taux_incapacite = parseInt(e.target.value);
        if (!isNaN(taux_incapacite)){
            this.setState(({demandeur})=>{
                demandeur.taux_incapacite =taux_incapacite/10;
                return {demandeur:demandeur};
            })
        }

    }

    handleChange =(e)=>{
        this.setState ( ({demandeur}) =>{
            demandeur.age = parseInt(e.target.value);
            return {demandeur : demandeur };
        });
    }

    captureNationalite = (newValue) =>{
        this.setState(({demandeur}) =>{
            demandeur.nationalite = newValue;
            if (demandeur.nationalite !== "Française"){
                demandeur.duree_possession_titre_sejour = 25;
            }
            return {demandeur : demandeur};
        })
    }
    
    changeDemandeurACharge = (newValue) =>{
        this.setState( ({demandeur})=> {
            demandeur.enfant_a_charge =  !JSON.parse(newValue);
            return {demandeur:demandeur};
        });
    }
    changeRsaCondition = (newValue)=>{
        this.setState( ({demandeur})=> {
            demandeur.rsa_jeune_condition_heures_travail_remplie =  JSON.parse(newValue);
            return {demandeur:demandeur};
        });
    }

    changeDureeSejourValide = (e) =>{
        const dureeSejourValide = e.target.checked;
        this.setState( ({demandeur})=> {
            if ( dureeSejourValide  === true) {
                demandeur.duree_possession_titre_sejour =   25;
            } else {
                delete demandeur.duree_possession_titre_sejour
            }
            return {demandeur:demandeur};
        });
    }
    switchRadio = (newValue , modelName)=>{
        this.setState(({demandeur})=>{
            demandeur[modelName] = JSON.parse(newValue);
            return {demandeur:demandeur}
        })
    }
    
    synchSituation = async () =>{
        for ( let situation in this.state.situations){
            this.setState( ({demandeur,situations})=>{
                demandeur[situation] = situations[situation].value;            
               
                if (situation === "retraite" && demandeur[situation]) {
                    demandeur.activite = 'retraite';
                } else if ( (situation === "inapte_travail" || situation==="aucune_situations") && demandeur[situation]){
                    demandeur.activite = 'inactif';
                }

                return {demandeur:demandeur};
            });
        }
    }
    getBirthDateFromAge = function (age) {
      const today = new Date();
      return new Date(today.getFullYear() - age, today.getMonth(), today.getDate() - 1);
    };

    nextForm = () =>{
        // synch data demandeur with situations .
        this.synchSituation()
        .then(()=>{
            // Send data to <simulateur> component .
            const data = { "demandeur" : this.state.demandeur } ;
            data.demandeur.date_naissance = this.getBirthDateFromAge(data.demandeur.age);

            let date = data.demandeur.date_fin_contrat == undefined ? new Date() : new Date(data.demandeur.date_fin_contrat.replace('/','/01/'));

            data.demandeur.date_fin_contrat = new Date(date - (3600*1000*24));

            this.props.validateStep(data)
        });
    }

    noSpecificSituation = ()=>{
        const noSpecificSituation =  Object.keys(this.state.situations).every( (  situation) =>{
            return this.state.situations[situation].value == false;
        });

        return noSpecificSituation ;
    }

    nextStep = () => {
        let validationPassed = true;

        if ( this.state.currentForm === 1 && (['undefined', NaN , undefined , null].includes(this.state.demandeur.age)|| this.state.demandeur.age <= 0) ) {
            validationPassed = false;
            this.setState({errorMessage : ['Veuillez saisir un age valide.'] });
        }
        
        if (this.state.currentForm === 3  && this.noSpecificSituation()) {
            validationPassed = false;
            this.setState({errorMessage : ["Veuillez renseigner votre situation."] } );
        }

        if (validationPassed){
            if (this.state.currentForm === 1 && this.state.demandeur.age < 62) {
                const data = { demandeur: this.state.demandeur };
                data.demandeur.date_naissance = this.getBirthDateFromAge(data.demandeur.age);
                this.props.validateStep(data, false, 4);
                return;
            }

            this.setState({
                currentForm  : this.state.currentForm+1,
                errorMessage : [],
            });

            if ( this.state.currentForm >= 3 ) {
                this.nextForm();
                document.getElementById('anchor').scrollIntoView({behavior:'smooth'}) ;
            }
        }
    }

    restart = () => {
        this.setState({currentForm : 1}); 
        this.props.restart();
    }


    questionDemandeurACharge = () =>{
        return  <div className="question-demandeur">
                    <RadioBox
                        name="demandeur-a-charge"
                        defaultValue={!this.state.demandeur.enfant_a_charge}
                        options={{"Oui":true, "Non":false}}
                        handler={this.changeDemandeurACharge}
                    >
                        <h4>Remplirez-vous &agrave; votre nom la prochaine d&eacute;claration d'imp&ocirc;ts&nbsp;?</h4>
                    </RadioBox>
                    
                </div>;
    }
    
    questionConditionRsa = ()=>{
        return <div className="question-demandeur">
                <RadioBox 
                    options={{"Oui":true,"Non":false}}
                    handler={this.changeRsaCondition}
                    defaultValue={this.state.demandeur.rsa_jeune_condition_heures_travail_remplie}
                    name="rsa_jeune_condition_heures_travail_remplie"
                >
                    <h4>Avez-vous eu une activité professionnelle à temps plein pendant au moins 2 ans au cours des 3 dernières années ?</h4>
                </RadioBox>
                    
                        
                </div>;
    }
    /*  Views methods  */
    demandeurAge = ()=>{
        return <div className="step-inner-container step-demandeur">
        <form onSubmit={this.nextStep}>
            <p>Si vous souhaitez estimer l’ASPA pour votre conjoint <InfoBulle message="Si vous souhaitez estimer les droits à l’ASPA pour la personne avec qui vous vivez, remplissez le profil ci-dessous selon ses informations. Ensuite, saisissez vos propres données dans le profil conjoint." /></p>
                <p className="step-title"><strong>Mon profil</strong></p>
                <div className="age">
                    <label htmlFor="age">Age</label>
                    <p> J'ai <input 
                        type="number"
                        name="age"
                        onChange={this.handleChange}
                        value = {this.state.demandeur.age}
                        placeholder="ex:30"
                    /> ans. </p>
                </div>
                { (this.state.demandeur.age>=18 && this.state.demandeur.age <= 24)?(
                    <>
                        { this.questionDemandeurACharge() }
                        { this.questionConditionRsa() }
                    </>
                    ) : ''}
                <FormError errors={this.state.errorMessage} />
                <input type="button" value="Valider" onClick={this.nextStep} />
        </form>
            </div>;
    }
    
    demandeurNationalite = ()=>{
        return <div className="step-inner-container">
                <p className="step-title"><strong>Mon profil</strong> </p>
        <div className="nationalite">
        <h3>Nationalité</h3>

        <div className="question" >
            <RadioBox 
                name="zone"
                options = {this.optionsNationalite}
                handler= {this.captureNationalite}
                defaultValue= {this.state.demandeur.nationalite}
            >
            </RadioBox>

        </div>
         { (this.state.demandeur.nationalite !== "FR" )?(
                 <div className="question"  >
                    <input  id="dSejour" checked={true} onChange={this.changeDureeSejourValide} type="checkbox"/>
                    <label className="custom-control-label" htmlFor="dSejour" >
                        Résidant en France plus de 9 mois par an
                    </label>
                 </div>
             ): ''}

        </div>
        <input type="button" value="Valider" onClick={this.nextStep}/>
        <input type="button" value="Recommencer" className="restart" onClick={this.restart}/>
        </div>;
    }
    //
   

    demandeurSituation = () => {
        var pourcentageHandicap;
        if (this.state.demandeur.taux_incapacite <0.5){
            pourcentageHandicap = "Moins de 50 %";
        } else if ( this.state.demandeur.taux_incapacite >= 0.5 && this.state.demandeur.taux_incapacite< 0.8) {
            pourcentageHandicap = "Entre 50% et 80%";
        }else if (this.state.demandeur.taux_incapacite >=0.8){
            pourcentageHandicap = "Plus de 80%";
        }

        const listSituation = [] ;
        for ( let situation in this.state.situations){
            listSituation.push({...this.state.situations[situation] , ...{name:situation}});
        }

        return  <div className="step-inner-container step-demandeur">
            <div className="situations-container">
                <p className="step-title"><strong>Mon profil</strong></p>
                <div className={"situation " + (this.state.showQuestionAdditionel? 'questions-situations-left' : '') 
                    +( this.state.showQuestionAdditionel=== false  ?  ' align-right' :'') }>
                    <h3>Situation</h3>
                    <div className="question">
                        <div className="situation-label">
                            <p>Vous êtes :</p>
                            <span className="indication-text">(plusieurs choix possibles)</span>
                        </div>

                        {listSituation.map(  (situation)=>{
                                return <div className="custom-checkbox" key={situation.name}>
                                    <label className="custom-control" htmlFor={situation.name} >
                                        <div className="checkbox-container" >
                                             <input type="checkbox"  
                                                 value={situation.name}
                                                 checked = {this.state.situations[situation.name].value}
                                                 onChange={(e)=>{this.changeSituationCheck(situation.name,e)}}
                                                 className="custom-control-input"
                                                 id={situation.name}/>
                                             <span className="checkmark"></span>
                                        </div>
                                   <span className="label" htmlFor={situation.name} >{situation.label}</span>
                            </label></div>;})}
                        <div className="clear"></div>
                    </div>
                </div>
                <div className={ 'questions-situations-right ' + (this.state.showQuestionAdditionel ? 'slide-in' : 'fade-out')}>
                    { (this.state.situations.handicap.value === true) ?
                        <>
                            <div className ="fade-in">
                               <h3>Votre taux d'incapacité</h3>
                               <small>(Evalué par votre MDPH)</small>
                               <input type="range"
                                    id="taux_incapacite"
                                    name="taux_incapacite"
                                    min="0"
                                    max="10"
                                    defaultValue={this.state.demandeur.taux_incapacite*10}
                                    onChange={this.captureTauxIncapacite}
                                    />
                                <small>{pourcentageHandicap}</small>
                            </div>

                            <div className = { 
                                (0.5 <= this.state.demandeur.taux_incapacite && this.state.demandeur.taux_incapacite < 0.8 )?
                                "fade-in" : "fade-out"
                            }>
                                
                                <RadioBox name="cdaph"
                                    options={{"Oui":true , "Non":false}}
                                    defaultValue= {this.state.demandeur.aah_restriction_substantielle_durable_acces_emploi}
                                    modelName="aah_restriction_substantielle_durable_acces_emploi"
                                    handler={this.switchRadio}
                                >
                                    <h3>Avez-vous une restriction substantielle et durable d'accès à l'emploi reconnue par la CDAPH ?</h3>
                                    <small>(Attention, cette restriction est différente de la reconnaissance de la qualité de travailleur handicapé.)</small>
                                </RadioBox>
                            </div>
                        </>
                        :''
                    }

                </div>
            </div>
            <FormError errors={this.state.errorMessage} />
            <input type="button" value="Valider" onClick={this.nextStep}/>
            <input type="button" value="Recommencer" className="restart" onClick={this.restart}/>
        </div>;

    }

    render () {
         
        if ( this.state.currentForm === 1 ) {
            return this.demandeurAge();
        } else if (this.state.currentForm === 2) {
            return this.demandeurNationalite();
        } else if (this.state.currentForm >= 3) {
            return this.demandeurSituation();
        }
    }
}

export default Demandeur;
